import Api from '@/api'

const api = new Api()
const bidApi = api.sales().bid()

export default {
  async fetchAll({ commit }, { bidNumber, ...queryParams }) {
    try {
      const { data } = await bidApi.equipments(bidNumber).fetchAll(queryParams)
      const equipment = data.data.equipments

      commit('setEquipments', equipment.models)

      return equipment
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
